import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 mb-10" };
const _hoisted_2 = { class: "grid gap-10 md:grid-cols-[0.8fr_1fr] lg:items-center" };
const _hoisted_3 = { class: "relative w-full" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
    key: 1,
    class: "flex h-full items-center justify-center text-2xl text-slate-400"
};
const _hoisted_6 = { class: "flex flex-col gap-6" };
const _hoisted_7 = {
    key: 0,
    class: "text-sm uppercase tracking-[0.3em] text-slate-500"
};
const _hoisted_8 = { class: "text-3xl font-bold text-slate-900 sm:text-4xl" };
const _hoisted_9 = { class: "text-lg text-slate-600" };
const _hoisted_10 = { class: "grid gap-4 sm:grid-cols-2" };
const _hoisted_11 = { class: "text-sm uppercase tracking-[0.2em] text-slate-500" };
const _hoisted_12 = { class: "text-2xl font-semibold text-slate-900" };
const _hoisted_13 = ["href"];
export default /*@__PURE__*/ _defineComponent({
    ...{ name: 'AboutUsSection' },
    __name: 'AboutUsSection',
    props: {
        heading: {},
        description: {},
        subheading: {},
        image: {},
        imageAlt: {},
        stats: { default: () => [] },
        ctaLabel: {},
        ctaHref: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (props.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: props.image,
                                alt: props.imageAlt ?? 'About us image',
                                loading: "lazy",
                                decoding: "async",
                                class: "h-full w-full object-cover"
                            }, null, 8 /* PROPS */, _hoisted_4))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, " Image "))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (props.subheading)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.subheading), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("h2", _hoisted_8, _toDisplayString(props.heading), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(props.description), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.stats, (stat) => {
                                return (_openBlock(), _createElementBlock("article", {
                                    key: stat.label,
                                    class: "flex flex-col rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-lg"
                                }, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(stat.label), 1 /* TEXT */),
                                    _createElementVNode("strong", _hoisted_12, _toDisplayString(stat.value), 1 /* TEXT */)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        (props.ctaLabel)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: props.ctaHref,
                                class: "inline-flex items-center justify-center rounded-full bg-red-600 px-6 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:bg-red-500"
                            }, _toDisplayString(props.ctaLabel), 9 /* TEXT, PROPS */, _hoisted_13))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
